import {blueColor, green500, greyishBlue50, red500, successColor} from "../../../../assets/jss/main";
import {makeStyles} from "@mui/styles";
import {ReactComponent as ValidatedIcon} from "../../../../assets/img/validated.svg";
import {ReactComponent as ErrorIcon} from "../../../../assets/img/error.svg";
import {ReactComponent as DangerIcon} from "assets/img/wms/danger.svg";
import {ReactComponent as RoundedBpCheckedIcon} from "assets/img/wms/roundedChecked.svg";

import PropTypes from "prop-types";
import React from "react";
import {ImageSharp} from "@mui/icons-material";

ThumbnailAndNotification.propsTypes = {
    children: PropTypes.node,
    link: PropTypes.string,
    alt: PropTypes.string,
    validated: PropTypes.bool,
    selected: PropTypes.bool,
}

const imageSize = '40px';
const borderRadius = '8px';
const useStyle = makeStyles({
    wmsValidatedImage: {
        "&::after": {
            content: '""',
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            borderRadius: borderRadius,
            backgroundColor: successColor,
            opacity: 0.4
        }
    },
    wmsErrorImage: {
        "&::after": {
            content: '""',
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            borderRadius: borderRadius,
            backgroundColor: red500,
            opacity: 0.4
        }
    },
    wmsSelectedImage: {
        "&::after": {
            content: '""',
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            borderRadius: borderRadius,
            backgroundColor: blueColor,
            opacity: 0.4
        }
    }
})

/**
 * This is the thumbnail and notification component.
 * It takes a link and an alt text and it will display it in a circle it also take a children when validated is false (it is false by default).
 * @returns {JSX.Element}
 */
export default function ThumbnailAndNotification({children, link, alt, selected = false, validated = false, error = false, unavailable = false}) {
    const classes = useStyle();

    function showIcon() {
        let Icon = null;

        if (selected) {
            Icon = RoundedBpCheckedIcon;
        }

        if (validated) {
            Icon = ValidatedIcon;
        }

        if (unavailable) {
            Icon = DangerIcon;
        }

        if (error) {
            Icon = ErrorIcon;
        }

        if (Icon) {
            return (
                <Icon
                    style={{
                        position: 'absolute',
                        top: '-15%',
                        right: '-15%',
                    }}
                />
            )
        }

        return <>{children}</>
    }

    return (
        <div style={{
            width: imageSize,
            height: imageSize,
            position: 'relative'}
        }>
            <div className={selected ? classes.wmsSelectedImage : validated ? classes.wmsValidatedImage : (unavailable || error) ? classes.wmsErrorImage : {}}>
                {link && (
                    <img style={{
                        borderRadius: borderRadius,
                        border: selected ? "1px solid " + blueColor : validated ? "1px solid " + green500 : "1px solid " + greyishBlue50,
                        objectFit: 'contain'
                    }}
                         width={imageSize}
                         height={imageSize}
                         src={link}
                         alt={alt}
                    />
                )}

                {!link && (
                    <ImageSharp color={"disabled"} sx={{fontSize: '40px'}}/>
                )}
            </div>
            {showIcon()}
        </div>
    )
}
